import * as React from "react";
import Head from "next/head";
import CookieConsent from "react-cookie-consent";
import Analytics from "./Analytics";
import { getCookie } from "../lib/getCookie";

export default function CookiesBanner() {
  const [cookiesAccepted, setCookiesAccepted] = React.useState(false);

  React.useEffect(() => {
    const cookieGA = getCookie("cookies_settings");
    if (cookieGA === "true") {
      setCookiesAccepted(true);
    } else {
      setCookiesAccepted(false);
    }
  }, []);

  return (
    <>
      {cookiesAccepted ? (
        <Analytics />
      ) : (
        <Head>
          <link rel="icon" type="image/ico" href="/las-letras-de/favicon.ico" />
        </Head>
      )}
      <CookieConsent
        onAccept={() => setCookiesAccepted(true)}
        onDecline={() => setCookiesAccepted(false)}
        location="bottom"
        buttonText={<>Aceptar todas</>}
        enableDeclineButton
        declineButtonText={<>Declinar</>}
        cookieName="cookies_settings"
        disableStyles={true}
        containerClasses="cookies-container"
        buttonWrapperClasses="cookies-buttons"
        contentClasses="cookies-inner"
      >
        <>
          Utilizamos cookies para que nuestra página funcione mejor. Esto
          incluye cookies analíticas y cookies publicitarias. Para obtener más
          información, visita nuestra{" "}
          <a href="https://badoo.com/es/cookie-policy/" target="_blank">
            Política de cookies.
          </a>
        </>
      </CookieConsent>
    </>
  );
}
